const steps = [
  {
    num: '1',
    title: 'Audit Your Current Workflow',
    description:
      'We analyze your current lead flow, scheduling process, and follow-up gaps. You get a clear picture of exactly where revenue is leaking and what to fix first.',
    icon: 'ri-search-eye-line',
  },
  {
    num: '2',
    title: 'Build Your Automation System',
    description:
      'Our team designs and configures your complete automation stack—AI call handling, booking flows, follow-up sequences, and dashboard setup—customized for your business.',
    icon: 'ri-tools-line',
  },
  {
    num: '3',
    title: 'Launch and Optimize',
    description:
      'Go live with a proven system. We monitor performance, tune sequences, and optimize for maximum booked jobs as your business scales.',
    icon: 'ri-rocket-2-line',
  },
];

export default function HowItWorks() {
  return (
    <section className="bg-[#F8FAFC] py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block bg-blue-100 text-blue-700 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4">
            The Process
          </span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-[#0F172A]">
            How It Works
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {steps.map((step) => (
            <div
              key={step.num}
              className="bg-white rounded-2xl p-10 border border-slate-100 text-center hover:-translate-y-1 transition-all"
            >
              <div className="text-7xl font-extrabold text-blue-600/15 leading-none mb-4">
                {step.num}
              </div>
              <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-2xl mx-auto mb-6">
                <i className={`${step.icon} text-blue-600 text-2xl`} />
              </div>
              <h3 className="text-[#0F172A] text-xl font-bold mb-4">
                {step.title}
              </h3>
              <p className="text-slate-500 text-sm leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
